let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kNScC")).then(() => parcelRequire('78mAq'));